import styled from "@emotion/styled";
import { fontAngkor, theme } from "@product/scmp-sdk";

import { Headline } from "scmp-app/components/posties/content-homepage/headline";

import GalaxyBackground from "./galaxy-background-image.png";

export const Container = styled.div`
  position: relative;

  padding-block-start: 60px;
  padding-inline: 24px;

  background-image: url(${GalaxyBackground.src});
  background-repeat: no-repeat;
  background-position: 50% 38%;
  background-size: 187% 364px;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 0;
    padding-inline: 40px;

    background-position: 50% 11%;
    background-size: auto;
  }

  ${theme.breakpoints.up("desktop")} {
    background-position: 50% 27%;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    padding-inline: 0;

    background-position: 50% 15%;
    background-size: 100% 745px;
  }
`;

export const Title = styled.div`
  color: #389810;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.72px;
  text-align: center;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
    line-height: 56px;
    letter-spacing: -0.96px;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-block-end: 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 56px;
  }
`;
